import { useState, useEffect, useCallback, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { Box, Grid, Typography } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import { collectionAPI } from 'services/admin';
import { Loaders } from 'components/Loader';
//import * as moment from 'moment';
import { VideoCard } from 'components/VideoCard';
import { getImageURL } from 'utils/tableListFormat';
import { thumbAdornment } from 'constants/homeApp';
import {
  useTableSelectedList,
  tableSelectedListUtility,
} from 'hooks/useTableSelectedList';
import { VideoOrSerieModal } from 'components/TableWithCheck/VideoOrSerieModal';
import {
  PAGE_COLLECTION_RELATED_VIDEO_COLLECTION_LIST,
  PAGE_COLLECTION_VIDEO_COLLECTION_SUGGESTION,
} from 'constants/app';
import { useNotification } from 'hooks/useNotification';

function CollectionStep4({ viewFields }) {
  const { setNotify } = useNotification();

  const [isLoadingRelated, setIsLoadingRelated] = useState(false);
  const params = useParams();

  const relatedVideoCollectionList = useTableSelectedList(
    PAGE_COLLECTION_RELATED_VIDEO_COLLECTION_LIST
  );

  const videoOrCollectionSuggestion = useTableSelectedList(
    PAGE_COLLECTION_VIDEO_COLLECTION_SUGGESTION
  );

  const nextContentSuggestion = useMemo(
    () => videoOrCollectionSuggestion.selectedItems?.[0],
    [videoOrCollectionSuggestion.selectedItems]
  );

  const [initialRelatedContents] = useState(
    () => relatedVideoCollectionList?.selectedItems
  );

  const getRelatedContents = useCallback(async () => {
    try {
      if (initialRelatedContents?.length) return;

      setIsLoadingRelated(true);
      const relatedData = await collectionAPI.get(
        `/${params?.id}/versions/${params?.version}/related-contents`
      );

      relatedVideoCollectionList.setSelectedItems(
        tableSelectedListUtility.mapRemoteDataToTable(
          relatedData.relatedContents
        )
      );
    } catch (error) {
      setNotify({
        isOpen: true,
        message: error.message,
        type: 'error',
        title: 'Passo 4: Erro ao buscar vídeos e coleções associadas.',
      });
    } finally {
      setIsLoadingRelated(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialRelatedContents]);

  useEffect(() => {
    getRelatedContents();
  }, [getRelatedContents]);

  return (
    <div className="step-container" id="collection-step-four">
      {/* <Box className={isLoading ? 'isLoading' : ''}>
        <Fade
          in={isLoading}
          style={{
            transitionDelay: isLoading ? '800ms' : '0ms',
          }}
          unmountOnExit>
          <CircularProgress />
        </Fade>
      </Box> */}

      {/* SUGESTÃO DE PRÓXIMO VÍDEO */}

      <Grid container spacing={2}>
        <Grid item xs={12}>
          <div
            className="video_label-title"
            style={{ marginTop: 40, marginBottom: 27 }}>
            Sugestão de próximo vídeo ou série
          </div>
          <span className="video-subtitle">
            {'Próximo vídeo/série sugerido'}{' '}
            <span style={{ fontSize: 12, color: '#6082B6' }}>(Máx. 1)</span>
          </span>
        </Grid>

        {nextContentSuggestion && (
          <>
            <div style={{ width: '100%', maxHeight: '400px' }}>
              <VideoCard.Root>
                <VideoCard.Image
                  variant="square"
                  image={getImageURL(nextContentSuggestion, 'SQUARE')}
                  size="small">
                  <VideoCard.CornerAdornment
                    name={
                      thumbAdornment[
                        nextContentSuggestion.contentType ||
                          nextContentSuggestion?.type ||
                          'VIDEO'
                      ]
                    }
                  />
                </VideoCard.Image>
                <Box>
                  <VideoCard.DescriptionDetail {...nextContentSuggestion} />
                  <Typography
                    variant="body2"
                    lineHeight="20px"
                    marginLeft="24px"
                    fontSize="12px"
                    color="#6F6B7D">
                    {(nextContentSuggestion.contentType ||
                      nextContentSuggestion?.type) === 'VIDEO' &&
                    nextContentSuggestion?.viewsLimit === 0
                      ? `Limite de Players:: ${nextContentSuggestion?.viewsLimit === 0}`
                      : ''}
                  </Typography>
                  <Typography
                    variant="body2"
                    lineHeight="20px"
                    fontSize="12px"
                    marginLeft="24px"
                    color="#6F6B7D">
                    {(nextContentSuggestion.contentType ||
                      nextContentSuggestion?.type) === 'VIDEO'
                      ? `Visualizações: ${nextContentSuggestion?.totalViews}`
                      : ''}
                  </Typography>
                </Box>
                <VideoCard.ActionsContainer>
                  <IconButton
                    disabled={viewFields}
                    aria-label="delete"
                    onClick={() => {
                      videoOrCollectionSuggestion.deleteSelectedItemsById(
                        nextContentSuggestion.id
                      );
                    }}
                    id="video-delete-relatedContent">
                    <DeleteOutlineOutlinedIcon
                      style={{ color: 'rgba(102, 112, 133, 1)' }}
                    />
                  </IconButton>
                </VideoCard.ActionsContainer>
              </VideoCard.Root>
            </div>
          </>
        )}

        <Grid item xs={12} align="right">
          <VideoOrSerieModal
            disabled={viewFields}
            itemName="Sugestão de vídeo ou série"
            openButtonLabel="Sugerir próximo vídeo ou série"
            backButtonLabel="Voltar"
            listId={PAGE_COLLECTION_VIDEO_COLLECTION_SUGGESTION}
            count={{
              selectedLength: videoOrCollectionSuggestion.selectedItems?.length,
              maxLength: 1,
            }}
            limitExceeded={
              videoOrCollectionSuggestion.selectedItems?.length === 1
            }
            disableGutters
          />
        </Grid>
      </Grid>
      {/* FIM SUGESTÃO DE PRÓXIMO VÍDEO */}
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <div
            className="video_label-title"
            style={{ marginTop: 40, marginBottom: 27 }}>
            Listagem de vídeos ou séries relacionadas
          </div>
          <span className="video-subtitle">
            {'Vídeos ou séries relacionadas'}{' '}
            <span style={{ fontSize: 12, color: '#6082B6' }}>(Máx. 20)</span>
          </span>
        </Grid>
        <div style={{ overflowY: 'scroll', width: '100%', maxHeight: '400px' }}>
          {isLoadingRelated && <Loaders.TableInfo />}
          {relatedVideoCollectionList.selectedItems?.map(related => (
            <VideoCard.Root key={related?.id}>
              <VideoCard.Image
                variant="vertical"
                image={getImageURL(related, 'VERTICAL')}
                size="small">
                <VideoCard.CornerAdornment
                  name={
                    thumbAdornment[related?.contentType || related?.type] ||
                    'VIDEO'
                  }
                />
              </VideoCard.Image>
              <Box>
                <VideoCard.DescriptionDetail {...related} />
                <Typography
                  variant="body2"
                  lineHeight="20px"
                  fontSize="12px"
                  marginLeft="24px"
                  color="#6F6B7D">
                  {(related?.contentType || related?.type) === 'VIDEO'
                    ? `Limite de Players: ${
                        related?.viewsLimit === 0
                          ? 'Ilimitado'
                          : related?.viewsLimit
                      } `
                    : ''}
                </Typography>
                <Typography
                  variant="body2"
                  lineHeight="20px"
                  fontSize="12px"
                  marginLeft="24px"
                  color="#6F6B7D">
                  {(related?.contentType || related?.type) === 'VIDEO'
                    ? `Visualizações: ${related?.totalViews}`
                    : ''}
                </Typography>
              </Box>
              <VideoCard.ActionsContainer>
                <IconButton
                  disabled={viewFields}
                  aria-label="delete"
                  onClick={() => {
                    relatedVideoCollectionList.deleteSelectedItemsById(
                      related.contentId || related.id
                    );
                  }}
                  id="video-delete-relatedContent">
                  <DeleteOutlineOutlinedIcon
                    style={{ color: 'rgba(102, 112, 133, 1)' }}
                  />
                </IconButton>
              </VideoCard.ActionsContainer>
            </VideoCard.Root>
          ))}
        </div>

        <Grid item xs={12} align="right">
          <VideoOrSerieModal
            disabled={viewFields}
            itemName="Listagem de vídeos ou séries relacionadas"
            openButtonLabel="Relacionar Vídeo ou Série"
            backButtonLabel="Voltar"
            listId={PAGE_COLLECTION_RELATED_VIDEO_COLLECTION_LIST}
            count={{
              selectedLength: relatedVideoCollectionList.selectedItems?.length,
              maxLength: 20,
            }}
            limitExceeded={
              relatedVideoCollectionList.selectedItems?.length >= 20
            }
            disableGutters
          />
        </Grid>
      </Grid>
    </div>
  );
}

export default CollectionStep4;
